// Renders a published read-model document (planning, completion, firm models) as a definition list, values verbatim.
// For screens whose full design comes later: the data is visible now, exactly as the engine computed it.
import type { ReactNode } from "react";
import { titleCase } from "../lib/format";

export function DocView({ doc, depth = 0 }: { doc: unknown; depth?: number }): ReactNode {
  if (doc === null || doc === undefined || doc === "") return <span className="italic text-muted">not recorded</span>;
  if (Array.isArray(doc)) {
    if (!doc.length) return <span className="italic text-muted">none</span>;
    return <ul className="list-disc space-y-0.5 pl-4">{doc.map((x, i) => <li key={i}><DocView doc={x} depth={depth + 1} /></li>)}</ul>;
  }
  if (typeof doc === "object") {
    return (
      <dl className={`grid grid-cols-[minmax(5rem,max-content)_minmax(0,1fr)] gap-x-4 gap-y-1 text-sm ${depth ? "rounded border border-line p-2" : ""}`}>
        {Object.entries(doc as Record<string, unknown>).map(([k, v]) => (
          <div key={k} className="contents"><dt className="text-muted">{titleCase(k)}</dt><dd className="min-w-0 break-words"><DocView doc={v} depth={depth + 1} /></dd></div>
        ))}
      </dl>
    );
  }
  return <span className={typeof doc === "number" ? "tabular-nums" : undefined}>{String(doc)}</span>;
}
